import * as actions from './actions'
import * as getters from './getters'
import { UPDATE_COMPANY_DATA } from './mutation-types'

const mutations = {
  [UPDATE_COMPANY_DATA] (state, company) {
    state.company = company
    localStorage.setItem('company', JSON.stringify(company))
    window.axios.defaults.headers.common['X-Company-Slug'] = company.slug
  }
}

export default {
  state: {
    company: JSON.parse(localStorage.getItem('company'))
  },
  actions,
  getters,
  mutations
}
